<template>
  <div class="guide-use" v-if="show">
    <div class="title">
      <i class="iconfont iconkzt_sckt_tz1"></i>
      您好，恭喜您成功开通{{title}}
    </div>
    <div class="step">
      <div class="step-one" v-if="showDocumentStep">
        <div class="one"><i class="iconfont iconkzt_sckt_1"></i></div>
        <div class="text">{{step}}</div>
      </div>
      <div class="step-two">
        <div class="two"><i class="iconfont iconkzt_sckt_21"></i></div>
        <div class="text">
          <span class="red">*</span>
          使用前，请<a @click="goConfigure">前往配置页面</a>
          知悉产品密钥以及设置IP白名单。
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getIpList } from '@/services/interface'

export default {
  name: 'guideUse',
  props: {
    title: { type: String },
    step: { type: String, default: '请先阅读右上角技术文档' },
    showDocumentStep: { type: Boolean, default: true }
  },
  data () {
    return {
      show: false
    }
  },
  mounted () {
    this.getIpList()
  },
  methods: {
    async getIpList () {
      const res = await getIpList().then((res) => {
        return res
      })
      console.log(res.data)
      if (res.data.length === 0) {
        this.show = true
      }
    },
    goConfigure () {
      this.$router.push({ path: '/configure' })
    }
  }
}
</script>

<style lang="scss">
  .guide-use {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px 0px rgba(17, 39, 98, 0.04);
    border-radius: 4px;
    padding: 39px 37px 56px;
    margin-bottom: 28px;

    .title {
      font-size: 14px;
      font-weight: 500;
      color: rgba(29, 36, 60, 1);
      line-height: 24px;
      margin-bottom: 28px;

      i {
        position: relative;
        top: 2px;
        font-size: 20px;
        margin-right: 5px;
        color: #003D92;
      }
    }

    .step {
      padding-left: 21px;
      display: flex;
      justify-content: left;

      .step-one {
        display: flex;
        justify-content: left;
        align-items: center;
        max-width: 306px;
        height: 97px;
        background: rgba(225, 237, 255, 1);
        padding: 0 25px;
        box-sizing: border-box;
        margin-right: 66px;

        .one {
          display: inline-block;
          width: 39px;
          height: 39px;
          background: rgba(0, 61, 146, 1);
          text-align: center;
          margin-right: 17px;

          i {
            color: #fff;
            font-size: 24px;
            line-height: 39px;
          }
        }

        .text {
          font-size: 14px;
          font-weight: 400;
          color: rgba(29, 36, 60, 1);
          line-height: 28px;
          margin-top: 4px;
        }
      }

      .step-two {
        max-width: 542px;
        height: 97px;
        background: rgba(225, 237, 255, 1);
        padding: 0 25px;
        box-sizing: border-box;
        display: flex;
        justify-content: left;
        align-items: center;

        .two {
          display: inline-block;
          width: 39px;
          height: 39px;
          background: rgba(0, 61, 146, 1);
          text-align: center;
          margin-right: 17px;

          i {
            color: #fff;
            font-size: 24px;
            line-height: 39px;
          }
        }

        .text {
          font-size: 14px;
          font-weight: 600;
          color: rgba(29, 36, 60, 1);
          line-height: 28px;
          margin-top: 4px;

          .red {
            color: #FF3939;
          }

          a {
            color: #3C8DFF;
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>
